import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IProjectName } from '../types/IProject';

export interface IGetProjectAncestorsByLuidParams extends IGetItemsParams {
  luid: string;
}

export interface IGetProjectAncestorsByLuidResult extends IResult {
  projects: IProjectName[];
}

export class GetProjectAncestorsByLuidRequest extends Request<IGetProjectAncestorsByLuidParams, IGetProjectAncestorsByLuidResult> {
  constructor(projectLuid: string) {
    super('getProjectAncestorsByLuid', { luid: projectLuid });
  }
}
